import { type PlaceholderType } from '@atlassian/conversation-assistant-ui-components/controllers/useEditorPlaceholder';

export function insertPromptPlaceholder(
	prompt: string,
	insertPlaceholder: (
		prompt: string,
		overrideType?: PlaceholderType,
		skillMetadata?: Record<string, { name: string; description: string; [key: string]: unknown }>,
	) => void,
	skillMetadataMap:
		| Record<string, { name: string; description: string; [key: string]: unknown }>
		| undefined,
): void {
	insertPlaceholder(prompt, undefined, skillMetadataMap);
}
